import React, { useState } from 'react'
import { Tooltip } from 'reactstrap'
import styles from '@bt-react/styles'
import componentStyles from './TooltipCentral.module.scss'
import Props from './types'

const TooltipCentral: React.FC<Props> = props => {

  const { children, id, content, placement, forDisabledElement } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
      
  const toggle = () => setTooltipOpen(!tooltipOpen);
    
  if(forDisabledElement){
  return (
    <>
      {children}
      <Tooltip
          placement={(placement) ? placement : 'auto'}
          container={typeof document !== 'undefined' && document.getElementsByClassName(styles['bootstrap-container'])[0] as HTMLElement}
          cssModule={styles}
          popperClassName={componentStyles['tooltip']}
          innerClassName={componentStyles['tooltip-inner']}
          arrowClassName={componentStyles['tootltip-arrow']}
          target={id}
          isOpen={tooltipOpen}
          toggle={toggle}
          data-bdd={(props.dataBdd ? props.dataBdd : '') + 'tooltip_text'}
      >
        {content}
      </Tooltip>
      </>
  );
  }

  return (
    <span>
      {children}
      <Tooltip
          placement={(placement) ? placement : 'auto'}
          container={typeof document !== 'undefined' && document.getElementsByClassName(styles['bootstrap-container'])[0] as HTMLElement}
          cssModule={styles}
          popperClassName={componentStyles['tooltip']}
          innerClassName={componentStyles['tooltip-inner']}
          arrowClassName={componentStyles['tootltip-arrow']}
          target={id}
          isOpen={tooltipOpen}
          toggle={toggle}
          data-bdd={(props.dataBdd ? props.dataBdd : '') + 'tooltip_text'}
      >
        {content}
      </Tooltip>
    </span>
  );
}

export default TooltipCentral
